<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Export {{ exportNameHumanReadable }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body" *ngIf="!loadingDownload">

    <div class="form-group">
      <label for="downloadFileNameInput">Download File Name</label>
      <input type="text" class="form-control" id="downloadFileNameInput" name="downloadFileName"
             [(ngModel)]="downloadFileName">
    </div>

    <div class="form-group">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="exportParentsAndGuardiansCheckbox"
               [(ngModel)]="exportParentsAndGuardians">
        <label class="form-check-label" for="exportParentsAndGuardiansCheckbox">
          Include parents and guardians in export
        </label>
      </div>
      <small class="text-muted form-text">
        This will include parents and guardians of the filtered customers. They will be added to the end of the export, after the filtered customers.
      </small>
    </div>

    <div class="form-group">
      <label>Columns:</label>
      <button class="btn btn-link btn-sm p-0 float-right"
              *ngIf="!allColumnsAreSelected()"
              (click)="setAllColumnsSelected(true)">
        Select All
      </button>
      <button class="btn btn-link btn-sm p-0 float-right"
              *ngIf="allColumnsAreSelected()"
              (click)="setAllColumnsSelected(false)">
        Deselect All
      </button>
      <br>
      <b>General</b>
      <div class="form-check" *ngFor="let columnName of generalColumnNames; let colIdx = index;">
        <input class="form-check-input" type="checkbox" [id]="'general' + colIdx + 'checkbox'"
               [(ngModel)]="selectedColumns[columnName]">
        <label class="form-check-label" [for]="'general' + colIdx + 'checkbox'">
          {{ columnName }}
        </label>
      </div>
      <ng-container *ngIf="customFieldColumnNames.length > 0">
        <b>Custom Fields</b>
        <div class="form-check" *ngFor="let columnName of customFieldColumnNames; let colIdx = index;">
          <input class="form-check-input" type="checkbox" [id]="'customField' + colIdx + 'checkbox'"
                 [(ngModel)]="selectedColumns[columnName]">
          <label class="form-check-label" [for]="'customField' + colIdx + 'checkbox'">
            {{ columnName }}
          </label>
        </div>
      </ng-container>
    </div>

  </div>

  <div class="modal-body" *ngIf="loadingDownload">
    <h4 *ngIf="!loadingParentsAndGuardians">Downloading customers...</h4>
    <h4 *ngIf="loadingParentsAndGuardians">Downloading parents and guardians...</h4>

    <div class="progress">
      <div class="progress-bar" role="progressbar" [style]="{width: getDownloadProgressPercentageStr() + '%'}"
           attr.aria-valuenow="{{ getDownloadProgressPercentageStr() }}" aria-valuemin="0" aria-valuemax="100"></div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            *ngIf="!loadingDownload"
            [disabled]="noColumnsAreSelected()"
            [class.disabled]="noColumnsAreSelected()"
            (click)="handleSubmit()">
      Export
    </button>
  </div>

</ng-container>
